'use client';

import { Flex, Grid, Text } from '@skin-seoul/design-system';
import SectionContainer from '@/components/shared/SectionContainer';
import SalePointCard from './components/SalePointCard';
import { salePoints } from '@skin-seoul/service';
import SectionHeader from '../../components/SectionHeader';
const WhySkinSeoulSection = () => {
  return <SectionContainer containerWrapperProps={{
    backgroundColor: 'generic.100'
  }} containerInnerProps={{
    paddingY: {
      base: '70px'
    }
  }} data-sentry-element="SectionContainer" data-sentry-component="WhySkinSeoulSection" data-sentry-source-file="WhySkinSeoulSection.tsx">
      <Flex direction="column" width="100%" gap={2} marginBottom={{
      base: 8,
      tablet: 12
    }} data-sentry-element="Flex" data-sentry-source-file="WhySkinSeoulSection.tsx">
        <SectionHeader href="/about-us/" title="Why SkinSeoul?" theme="dark" data-sentry-element="SectionHeader" data-sentry-source-file="WhySkinSeoulSection.tsx" />

        <Text color="neutral.200" textStyle="paragraph.medium" fontWeight="regular" data-sentry-element="Text" data-sentry-source-file="WhySkinSeoulSection.tsx">
          Here Are Four Reasons You&apos;ll Love Us
        </Text>
      </Flex>
      <Grid gap={{
      base: 2,
      tablet: 3
    }} templateColumns={{
      base: 'repeat(2, 1fr)',
      tablet: 'repeat(4, 1fr)'
    }} width="100%" data-sentry-element="Grid" data-sentry-source-file="WhySkinSeoulSection.tsx">
        {salePoints.map(point => <SalePointCard icon={point.icon} key={point.subtitle} subtitle={point.subtitle} title={point.title} />)}
      </Grid>
    </SectionContainer>;
};
export default WhySkinSeoulSection;